import { z } from 'zod';
import { UUIDSchema } from '../ids.js';
export const IntercomCallStatusSchema = z.enum([
    'queued',
    'answered',
    'ended',
    'missed',
]);
export const IntercomCallDirectionSchema = z.enum(['inbound', 'outbound']);
export const IntercomCallSchema = z.object({
    id: UUIDSchema,
    tenant_id: UUIDSchema,
    callbox_id: UUIDSchema,
    controller_call_id: z.string().nullable(),
    direction: IntercomCallDirectionSchema,
    status: IntercomCallStatusSchema,
    initiated_at: z.string(),
    answered_at: z.string().nullable(),
    ended_at: z.string().nullable(),
    answered_by_user_id: UUIDSchema.nullable(),
    snapshot_ids: z.array(z.string()),
    notes: z.string().nullable(),
});
export const AnswerIntercomCallBody = z.object({
    notes: z.string().max(500).optional(),
});
export const EndIntercomCallBody = z.object({
    reason: z
        .enum(['operator_ended', 'caller_hung_up', 'transferred', 'timeout'])
        .default('operator_ended'),
    notes: z.string().max(500).optional(),
});
//# sourceMappingURL=intercom.js.map